import { produce } from "immer";
import {
  SEARCH_TAG,
  SEARCH_TAG_FAILURE,
  SEARCH_TAG_SUCCESS,
  UPDATE_FEED_TAGS,
  DELETE_TAG,
  DELETE_TAG_SUCCESS,
  DELETE_TAG_FAILURE,
  RESET_FEED_TAGS,
  ADD_REACTION,
  ADD_REACTION_SUCCESS,
  ADD_REACTION_FAILURE,
  FETCH_REACTIONS,
  FETCH_REACTIONS_SUCCESS,
  FETCH_REACTIONS_FAILURE,
  FETCH_SEEN_USERS,
  FETCH_SEEN_USERS_SUCCESS,
  FETCH_SEEN_USERS_FAILURE,
  FETCH_EVENT_RSVP_LIST,
  FETCH_EVENT_RSVP_LIST_SUCCESS,
  FETCH_EVENT_RSVP_LIST_FAILURE,
  TOGGLE_REACTION_MODAL,
  ACKNOWLEDGE_FEED,
  ACKNOWLEDGE_FEED_SUCCESS,
  ACKNOWLEDGE_FEED_FAILURE,
  RECORD_FEED_VIEW,
  RECORD_FEED_VIEW_SUCCESS,
  RECORD_FEED_VIEW_FAILURE,
  TOGGLE_REPORT_MODAL,
  FETCH_STATS,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  FETCH_ENGAGE_REPORT,
  FETCH_ENGAGE_REPORT_SUCCESS,
  FETCH_ENGAGE_REPORT_FAILURE,
  ENGAGE_REPORT_FILTERS,
  TOGGLE_OPTION_MODAL,
  GET_KUDOS_LEADERBOARD,
  GET_KUDOS_LEADERBOARD_SUCCESS,
  GET_KUDOS_LEADERBOARD_FAILURE,
  KUDOS_LEADERBOARD_FILTERS,
  FETCH_KUDOS_REPORT,
  FETCH_KUDOS_REPORT_SUCCESS,
  FETCH_KUDOS_REPORT_FAILURE,
  KUDOS_REPORT_FILTERS,
  FETCH_VALUES_REPORT,
  FETCH_VALUES_REPORT_SUCCESS,
  FETCH_VALUES_REPORT_FAILURE,
  VALUES_REPORT_FILTERS,
  FETCH_COMPANY_SCORECARD_REPORT,
  FETCH_COMPANY_SCORECARD_REPORT_SUCCESS,
  FETCH_COMPANY_SCORECARD_REPORT_FAILURE,
  PIN_FEED,
  PIN_FEED_SUCCESS,
  PIN_FEED_FAILURE,
  EXPORT_ACKNOWLEDGED_FEEDS,
  EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS,
  EXPORT_ACKNOWLEDGED_FEEDS_FAILURE,
} from "./constants";

export const initialState = {
  isSearchingTag: false,
  tags: {},
  feedTags: [],
  isAddingReaction: false,
  isAddingComment: false,
  reactions: {},
  comments: {},
  // Reactions
  isFetchingReactions: false,
  reactions: null,
  isFetchingSeenUsers: false,
  seenUsers: [],
  isFetchingEventRsvpList: false,
  eventRsvpList: [],
  reactionModal: {
    open: false,
  },
  isAcknowledgingFeed: false,
  recordingFeedViewIds: {},
  reportModal: {
    open: false,
  },
  // Stats
  isFetchingStats: false,
  stats: {},
  // Engage Report
  isFetchingEngageReport: false,
  engageReport: {},
  engageReportFilters: {},
  // Option Modal
  optionModal: {
    open: false,
  },
  // Kudos Leaderboard
  isFetchingKudosLeaderboard: false,
  kudosLeaderboard: [],
  kudosLeaderboardFilters: {},
  isFetchingKudosReport: false,
  kudosReport: {},
  kudosReportFilters: {
    companyReport: false,
  },
  isFetchingValuesReport: false,
  valuesReport: {},
  valuesReportFilters: {
    companyLeaderboard: false,
  },
  isFetchingCompanyScorecardReport: false,
  companyScorecardReport: {},
  // Pin Feed
  isPinningFeed: false,
  // Export Acknowledged Feeds
  isExportingAcknowledgedFeeds: false,
};

const FeedActionReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SEARCH_TAG:
        draft.isSearchingTag = true;
        draft.tags = {};
        break;
      case SEARCH_TAG_SUCCESS:
        draft.isSearchingTag = false;
        draft.tags = action.payload;
        break;
      case SEARCH_TAG_FAILURE:
        draft.isSearchingTag = false;
        draft.tags = {};
        break;
      case UPDATE_FEED_TAGS:
        draft.feedTags = action.payload;
        break;
      case DELETE_TAG:
        draft.isDeletingTag = true;
        break;
      case DELETE_TAG_SUCCESS:
        draft.isDeletingTag = false;
        break;
      case DELETE_TAG_FAILURE:
        draft.isDeletingTag = false;
        break;
      case RESET_FEED_TAGS:
        draft.feedTags = [];
        break;
      case ADD_REACTION:
        draft.isAddingReaction = true;
        break;
      case ADD_REACTION_SUCCESS:
        draft.isAddingReaction = false;
        break;
      case ADD_REACTION_FAILURE:
        draft.isAddingReaction = false;
        break;
      case FETCH_REACTIONS:
        draft.isFetchingReactions = true;
        draft.reactions = {};
        break;
      case FETCH_REACTIONS_SUCCESS:
        draft.isFetchingReactions = false;
        draft.reactions = action.payload;
        break;
      case FETCH_REACTIONS_FAILURE:
        draft.isFetchingReactions = false;
        draft.reactions = {};
        break;
      case FETCH_SEEN_USERS:
        draft.isFetchingSeenUsers = true;
        draft.seenUsers = [];
        break;
      case FETCH_SEEN_USERS_SUCCESS:
        draft.isFetchingSeenUsers = false;
        draft.seenUsers = action.payload;
        break;
      case FETCH_SEEN_USERS_FAILURE:
        draft.isFetchingSeenUsers = false;
        draft.seenUsers = [];
        break;
      case FETCH_EVENT_RSVP_LIST:
        draft.isFetchingEventRsvpList = true;
        draft.eventRsvpList = [];
        break;
      case FETCH_EVENT_RSVP_LIST_SUCCESS:
        draft.isFetchingEventRsvpList = false;
        draft.eventRsvpList = action.payload;
        break;
      case FETCH_EVENT_RSVP_LIST_FAILURE:
        draft.isFetchingEventRsvpList = false;
        draft.eventRsvpList = [];
        break;
      case TOGGLE_REACTION_MODAL:
        draft.reactionModal = action.payload;
        break;
      case ACKNOWLEDGE_FEED:
        draft.isAcknowledgingFeed = true;
        break;
      case ACKNOWLEDGE_FEED_SUCCESS:
        draft.isAcknowledgingFeed = false;
        break;
      case ACKNOWLEDGE_FEED_FAILURE:
        draft.isAcknowledgingFeed = false;
        break;
      case RECORD_FEED_VIEW:
        if (action.payload) {
          draft.recordingFeedViewIds[action.payload] = true;
        }
        break;
      case RECORD_FEED_VIEW_SUCCESS:
      case RECORD_FEED_VIEW_FAILURE: {
        const feedId = action.payload?.feedId ?? action.payload;
        if (feedId) {
          delete draft.recordingFeedViewIds[feedId];
        }
        break;
      }
      case TOGGLE_REPORT_MODAL:
        draft.reportModal = action.payload;
        break;
      case FETCH_STATS:
        draft.isFetchingStats = true;
        draft.stats = {};
        break;
      case FETCH_STATS_SUCCESS:
        draft.isFetchingStats = false;
        draft.stats = action.payload;
        break;
      case FETCH_STATS_FAILURE:
        draft.isFetchingStats = false;
        draft.stats = {};
        break;
      case FETCH_ENGAGE_REPORT:
        draft.isFetchingEngageReport = true;
        draft.engageReport = {};
        break;
      case FETCH_ENGAGE_REPORT_SUCCESS:
        draft.isFetchingEngageReport = false;
        draft.engageReport = action.payload;
        break;
      case FETCH_ENGAGE_REPORT_FAILURE:
        draft.isFetchingEngageReport = false;
        draft.engageReport = {};
        break;
      case ENGAGE_REPORT_FILTERS:
        draft.engageReportFilters = action.payload;
        break;
      case TOGGLE_OPTION_MODAL:
        draft.optionModal = action.payload;
        break;
      case GET_KUDOS_LEADERBOARD:
        draft.isFetchingKudosLeaderboard = true;
        draft.kudosLeaderboard = [];
        break;
      case GET_KUDOS_LEADERBOARD_SUCCESS:
        draft.isFetchingKudosLeaderboard = false;
        draft.kudosLeaderboard = action.payload;
        break;
      case GET_KUDOS_LEADERBOARD_FAILURE:
        draft.isFetchingKudosLeaderboard = false;
        draft.kudosLeaderboard = [];
        break;
      case KUDOS_LEADERBOARD_FILTERS:
        draft.kudosLeaderboardFilters = action.payload;
        break;
      case FETCH_KUDOS_REPORT:
        draft.isFetchingKudosReport = true;
        draft.kudosReport = {};
        break;
      case FETCH_KUDOS_REPORT_SUCCESS:
        draft.isFetchingKudosReport = false;
        draft.kudosReport = action.payload ?? {};
        break;
      case FETCH_KUDOS_REPORT_FAILURE:
        draft.isFetchingKudosReport = false;
        draft.kudosReport = {};
        break;
      case KUDOS_REPORT_FILTERS:
        draft.kudosReportFilters = action.payload;
        break;
      case FETCH_VALUES_REPORT:
        draft.isFetchingValuesReport = true;
        draft.valuesReport = {};
        break;
      case FETCH_VALUES_REPORT_SUCCESS:
        draft.isFetchingValuesReport = false;
        draft.valuesReport = action.payload ?? {};
        break;
      case FETCH_VALUES_REPORT_FAILURE:
        draft.isFetchingValuesReport = false;
        draft.valuesReport = {};
        break;
      case VALUES_REPORT_FILTERS:
        draft.valuesReportFilters = action.payload;
        break;
      case FETCH_COMPANY_SCORECARD_REPORT:
        draft.isFetchingCompanyScorecardReport = true;
        draft.companyScorecardReport = {};
        break;
      case FETCH_COMPANY_SCORECARD_REPORT_SUCCESS:
        draft.isFetchingCompanyScorecardReport = false;
        draft.companyScorecardReport = action.payload ?? {};
        break;
      case FETCH_COMPANY_SCORECARD_REPORT_FAILURE:
        draft.isFetchingCompanyScorecardReport = false;
        draft.companyScorecardReport = {};
        break;
      case PIN_FEED:
        draft.isPinningFeed = true;
        break;
      case PIN_FEED_SUCCESS:
        draft.isPinningFeed = false;
        break;
      case PIN_FEED_FAILURE:
        draft.isPinningFeed = false;
        break;

      case EXPORT_ACKNOWLEDGED_FEEDS:
        draft.isExportingAcknowledgedFeeds = true;
        break;
      case EXPORT_ACKNOWLEDGED_FEEDS_SUCCESS:
        draft.isExportingAcknowledgedFeeds = false;
        break;
      case EXPORT_ACKNOWLEDGED_FEEDS_FAILURE:
        draft.isExportingAcknowledgedFeeds = false;
        break;
      default:
        return state;
    }
  });

export default FeedActionReducer;
